<template>
  <div>
    <order-info :info="info"/>
    <evaluative-info/>
    <el-row class="form-container">
      <div class="el-descriptions-title">产品质量评价申请人信息</div>
      <apply-info :applyInfo="info"></apply-info>
    </el-row>
    <supply-service-capability ref="supplyService" :is-details="isDetails" :info="info"
                               :supplier-type="info.supplierType" @audit="onAudit"/>
    <div v-if="!isDetails" class="form-container">
      <div class="el-descriptions-title">审核信息</div>
      <div class="tip">标 <span class="required">*</span> 号的供应服务能力必须全部确认，否则无法提交。</div>
      <el-form style="width: 50%" :rules="rules" :model="form" label-width="95px" ref="form">
        <el-form-item label="审核结果：" prop="auditResult">
          <el-radio-group v-model="form.auditResult">
            <el-radio :disabled="disabled" label="1">确认</el-radio>
            <el-radio label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见：" prop="reason">
          <el-input v-model="form.reason" placeholder="请输入"
                    type="textarea" :maxlength="1000" show-word-limit :rows="2">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div v-else class="form-container">
      <div class="el-descriptions-title">审核历史</div>
      <auditHistoryInfo type="1"></auditHistoryInfo>
    </div>
    <div :style="{'text-align': isDetails?'left':'right'}">
      <eui-btn v-if="isDetails" type="secondary" @click="onCancel">返 回</eui-btn>
      <template v-else>
        <eui-btn type="secondary" @click="onCancel">取 消</eui-btn>
        <eui-btn type="primary"  v-debounce="onSubmit">提 交</eui-btn>
      </template>
    </div>
  </div>
</template>

<script>
  import eTableList from '@/modules/projectA/components/common/e-table-list';
  import supplyServiceCapability from '../components/supplyServiceCapability';
  import evaluativeInfo from '../components/evaluativeInfo';
  import orderInfo from '../components/orderInfo';
  import auditHistoryInfo from '../ESapply/component/auditHistoryInfo.vue';
  import applyInfo from '../ESapply/component/applyInfo.vue';
  import Api from '@/modules/projectA/api/ESorganization';
  import bus from '@/components/common/bus';

  export default {
    name: 'enterpriseInfoReviewReview',
    components: { eTableList, supplyServiceCapability, evaluativeInfo, auditHistoryInfo, applyInfo,orderInfo },
    props: {
      // 是否是详情页面
      isDetails: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        tableData: [{ applyCode: '123.11', applyCode1: '123123123132asdasdasdasdacxzzczxczxczxczxczxczxczxczxczxc' }],
        form: {
          auditResult: '',
          reason: ''
        },
        auditList: [],
        // 为true时只能驳回
        disabled: false,
        // 基础信息
        info: {}
      };
    },
    computed: {
      rules() {
        return {
          auditResult: [{ required: true, message: '请选择' }],
          reason: [{ required: this.form.auditResult === '2', message: '请输入' }]
        };
      }
    },
    created() {
      this.getData();
    },
    methods: {
      /**
       * 审核资质信息和供应服务能力
       * @param data
       * @param reason
       */
      onAudit(data, reason) {
        this.auditList = data;
        this.form.reason = reason;
        this.disabled = !!reason;
        if (reason) {
          this.form.auditResult = '2';
        }
      },
      /**
       * 获取基础信息
       */
      getData() {
        Api.getEvaluationApplyDetail({
          applyId: this.$route.query.applyId
        }).then(res => {
          if (res.code === '200') {
            this.info = res.data;
          }
        });
      },
      /**
       * 取消
       */
      onCancel() {
        bus.$emit('close_current_tags');
      },
      /**
       * 提交
       */
      onSubmit() {
        // 有未审核的必须审核项
        if (this.$refs.supplyService.verify()) {
          this.$refs.form.validate((valid) => {
            if (valid) {
              Api.auditEvaluationApplyDataReviewInfo({
                applyId: this.$route.query.applyId,
                confirmList: this.auditList,
                ...this.form
              }).then(res => {
                if (res.code === '200') {
                  this.$message.success('操作成功');
                  this.onCancel();
                }
              });
            }
          });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "../components/common";
</style>